import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <span className="inline-flex items-center gap-3 uppercase text-xs tracking-[0.25em] font-semibold text-[#D4AF37]">
    <span className="h-px w-8 bg-[#D4AF37]" /> {children}
  </span>
);
